import React from "react";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import ProductBanner from "../bannners/ProductBanner";

function Products({ sliderProducts }) {
  return (
    <div className="et-boc">
      <Header />
      <div id="et-main-area">
        <div id="main-content">
          <ProductBanner sliderProducts={sliderProducts} />
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default Products;
